import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import BidsList from "./BidsList";

let routes = [
  {
    path: 'bids',
    name: 'bids',
    component: BidsList,
    meta: {
      requiresAuth: true
    }
  },
];

export default {
  menuItem: new MenuItem('/bids', i18n.t('Bids'), 30, 'user-friends', [], 'view_auction'),
  routes: routes
}
